/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_Ten_FramesInputs */

const en_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse 10 Frame`)
};

const fr_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reculer de 10 images`)
};

const de_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückwärts-10-Rahmen`)
};

const it_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotogramma inverso 10`)
};

const ru_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратная сторона 10-кадровой рамки`)
};

const es_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco 10 inverso`)
};

const zh_cn2_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反向10帧`)
};

const ja_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リバース10フレーム`)
};

const hi_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवर्स 10 फ्रेम`)
};

const pt_pt2_shortcut_keys_name_reverse_ten_frames = /** @type {(inputs: Shortcut_Keys_Name_Reverse_Ten_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro reverso 10`)
};

/**
* | output |
* | --- |
* | "Reverse 10 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_Ten_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_ten_frames = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_Ten_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_Ten_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "de") return de_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "it") return it_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "es") return es_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_reverse_ten_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_reverse_ten_frames(inputs)
	return en_shortcut_keys_name_reverse_ten_frames(inputs)
});